/*!
 * @license MIT
 * youbora-adapter-freewheel 6.1.2
 * Copyright NicePopleAtWork <http://nicepeopleatwork.com/>
 * @author Jesus Lopez
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

//var youbora = require('youboralib')
var manifest = __webpack_require__(1)

youbora.adapters.Freewheel = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function() {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function() {
    return this.player.videoEl.currentTime
  },

  /** Override to return video duration */
  getDuration: function() {
    return this.player.videoEl.duration
  },

  /** Override to return title */
  getTitle: function() {
    if (this.titles) {
      return this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId
    }
    return "unknown"
  },

  /** Override to return resource URL. */
  getResource: function() {
    return this.player.videoEl.currentSrc
  },

  /** Override to return player version */
  getPlayerVersion: function() {
    return tv.freewheel.SDK.version
  },

  /** Override to return player's name */
  getPlayerName: function() {
    return "Freewheel"
  },

  getPosition: function() {
    return this.position
  },

  /** Register listeners to this.player. */
  registerListeners: function() {

    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references[tv.freewheel.SDK.EVENT_AD_IMPRESSION_END] = this.endedListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_IMPRESSION] = this.playListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_PAUSE] = this.pauseListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_RESUME] = this.resumeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_SKIPPED] = this.skipListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD] = this.logListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_SLOT_STARTED] = this.slotListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_SLOT_ENDED] = this.closeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_CLICK] = this.clickListener.bind(this)
      // Register listeners
    for (var key in this.references) {
      this.player.currentAdContext.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function() {
    // Disable playhead monitoring
    this.monitor.stop()
      // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.currentAdContext.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  slotListener: function(e) {
    var position = e.slot.getTimePositionClass()
    this.disable = false
    if (position === "POSTROLL") {
      this.position = "post"
    } else if (position === "MIDROLL") {
      this.position = "mid"
    } else if (position === "PREROLL") {
      this.position = "pre"
    } else {
      this.disable = true
    }
    if (!this.disable) {
      this.titles = e.slot.getAdInstances()
      if (this.plugin.getAdapter()) {
        this.plugin.getAdapter().unregisterListeners()
      }
      this.plugin.fireInit()
      this.fireInit()
    }
  },
  playListener: function(e) {
    if (this.disable) return null
    this.fireStart()
    this.fireJoin()
  },
  pauseListener: function(e) {
    this.firePause()
  },
  resumeListener: function(e) {
    this.fireResume()
  },
  endedListener: function(e) {
    this.fireStop()
  },
  skipListener: function(e) {
    this.fireStop({ skipped: true })
  },
  logListener: function(e) {
    youbora.Log.debug(e.subType)
  },
  clickListener: function(e) {
    this.fireClick()
  },
  closeListener: function(e) {
    if (this.plugin.getAdapter()) {
      this.plugin.getAdapter().registerListeners()
    }
    if (this.position === "post" && !this.disable) {
      this.plugin.fireStop({ end: true })
    }
  }
})

module.exports = youbora.adapters.Freewheel

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = {"name":"freewheel","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.2","built":"2018-03-12","repo":"https://bitbucket.org/npaw/freewheel-adapter-js","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"]},"ads":[]}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

youbora.registerAdapter('Freewheel', __webpack_require__(0))
  //module.exports = youbora

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// sp.min.js